import {
  CABLECAR_CONNECTED,
  CABLECAR_DISCONNECTED,
  CABLECAR_LOADED,
} from 'reduxes/slices/cablecar/actions'

export function cablecar(state = { isConnected: false }, action) {
  switch (action.type) {
    case CABLECAR_LOADED:
      return Object.assign({}, state, action.cablecar)
    case CABLECAR_CONNECTED:
      return {
        ...state,
        isConnected: true,
      }
    case CABLECAR_DISCONNECTED:
      return {
        ...state,
        isConnected: false,
      }
    default:
      return state
  }
}
